import { Action } from 'redux';

import { RemoveAlert } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface RemoveAlertAction extends Action {
  alertId: string;
}

export function removeAlertAction(alertId: string): RemoveAlertAction {
  return {
    type: RemoveAlert,
    alertId: alertId
  };
}

export const isRemoveAlertAction = isActionFactory<RemoveAlertAction>(RemoveAlert);
